<!--
 * @Author: awu
 * @Date: 2020-12-01 22:29:29
 * @LastEditors: awu
 * @LastEditTime: 2020-12-01 22:48:31
 * @Description: pdf展示
-->
<template>
  <div class="pdf">
     <pdf
      ref="pdf"
      v-for="i in numPages" 
      :key="i"  
      :src="url" 
      :page="i"
      ></pdf>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  components:{
      pdf
  },
  data(){
      return {
          url:"https://pdf.maitube.com/pdf/?e=agQRuAtaPviyQa",
          numPages: null, // pdf 总页数
      }
  },
  mounted() {
      this.getNumPages()
  },
  methods: {
     getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.url)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
  
  }
}
</script>

<style lang="scss" scoped>
    .pdf{
        width: 800px;
        height: 427px;
        background: #ffffff;
        box-shadow: 0px 5px 7px 3px rgba(0, 0, 0, 0.3);
        border-radius: 20px;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .box{
            width: 567px;
            height: 256px;
            overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/consult/pdf.vue